import { Injectable } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';
@Injectable({
  providedIn: 'root',
})
export class LottieService {
  private coinSpinOptions: AnimationOptions = {
    path: '/assets/animations/coins-spin.json',
    loop: true,
    autoplay: true,
  };
  private coinJumpOptions: AnimationOptions = {
    path: '/assets/animations/coins-jump.json',
    loop: true,
    autoplay: true,
  };
  private medalOptions: AnimationOptions = {
    path: '/assets/animations/medal-first-place.json',
    loop: true,
    autoplay: true,
  };
  private bookOptions: AnimationOptions = {
    path: '/assets/animations/wired-flat-book.json',
    loop: true,
    autoplay: true,
  };

  private coinOptions: AnimationOptions = {
    path: '/assets/animations/coin.json',
    loop: true,
    autoplay: true
  };
  private newspaperAnimationOptions: AnimationOptions = {
    path: '/assets/animations/newspaper.json',
    loop: true,
    autoplay: true
  };
  private booksAnimationOptions: AnimationOptions = {
    path: '/assets/animations/book2.json',
    loop: false,
    autoplay: true,
    // The "red book" layer's own out-point is frame 144 (composition runs to 180):
    // past it lottie stops drawing it, which reads as the icon vanishing. Stopping
    // the segment right before that keeps the last rendered frame fully visible.
    initialSegment: [0, 96],
  };
  private starAnimationOptions: AnimationOptions = {
    path: '/assets/animations/star.json',
    loop: false,
    autoplay: true,
    // Same cause: the star graphic's out-point is frame 91 (composition runs to 107);
    // after it only trailing sparks remain. Freeze just before it disappears.
    // initialSegment: [0, 84],
  };
  private starAnimationOptions2: AnimationOptions = {
    path: '/assets/animations/star.json',
    loop: true,
    autoplay: true,
    // Same cause: the star graphic's out-point is frame 91 (composition runs to 107);
    // after it only trailing sparks remain. Freeze just before it disappears.
    // initialSegment: [0, 84],
  };
  private sadFaceAnimationOptions: AnimationOptions = {
    path: '/assets/animations/sad-face.json',
    loop: false,
    autoplay: true
  };

  private thumbsUpAnimationOptions: AnimationOptions = {
    path: '/assets/animations/thumbs-up.json',
    loop: false,
    autoplay: true,
  };

  private animationItem: AnimationItem;

  constructor() {}

  public get _coinSpinOptions() {
    return this.coinSpinOptions;
  }
  public get _coinJumpOptions() {
    return this.coinJumpOptions;
  }
  public get _medalOptions() {
    return this.medalOptions;
  }
  public get _coinOptions() {
    return this.coinOptions;
  }
  public get _bookOptions() {
    return this.bookOptions;
  }
  public get _newspaperAnimationOptions() {
    return this.newspaperAnimationOptions;
  }
  public get _booksAnimationOptions() {
    return this.booksAnimationOptions;
  }
  public get _starAnimationOptions() {
    return this.starAnimationOptions;
  }
  public get _starAnimationOptions2() {
    return this.starAnimationOptions2;
  }
  public get _sadFaceAnimationOptions() {
    return this.sadFaceAnimationOptions;
  }

  public get _thumbsUpAnimationOptions() {
    return this.thumbsUpAnimationOptions;
  }

  setLowAnimationSpeed(animationItem: AnimationItem): void {
    this.animationItem = animationItem;
    this.animationItem.setSpeed(0.3);
  }
}
